<template>
    <div>

        <div class="menu_div">
            <div v-for="(item, i) in menu_list" :key="i" @click="to_page(item)" class="menu_item">
                <div class="menu_button">
                    <div class="icondiv">
                        <span class="iconfont iconybxm"></span>
                    </div>
                    <div class="menu_txt">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div @click="quit_button">
            退出登录
        </div>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    data() {
        return {
            menu_list: [
                { name: '常规项目', path: '/h5/my_project' }
            ],
            qr_result: {}
        }
    },
    mounted() {
        this.get_wx_params_info()
    },
    methods: {


        //确认退出
        quit_button() {
            this.$cookies.remove('dx_token')
            this.$cookies.remove('dx_private_key')
            this.$cookies.remove('dx_public_key')
            this.$cookies.remove('dx_user_info')



            var login_url = process.env.VUE_APP_LOGIN_URL
            var auth_url = process.env.VUE_APP_AUTH_URL
            var url = auth_url + '?redirect_url=' + login_url
            open_new_page(url, '_self')


        },



        saoyisao() {
            var that = this
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    console.log(result)
                    that.qr_result = result
                }
            });
        },

        isIOS() {
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        },

        //获取微信js 参数
        get_wx_params_info() {
            var that = this

            if(this.isIOS()){
                var href = 'https://project.daxiangsys.com/'
            }else{
                var href = window.location.href
            }
            
            var obj = {
                href: href
            }
            http("post", process.env.VUE_APP_HOST + "/wxmp/jssdk/params_info", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        console.log(res)
                        var info = res.data.info
                        console.log(info)
                        wx.config({
                            debug:info.debug, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                            appId: info.appId, // 必填，公众号的唯一标识
                            timestamp: info.timestamp, // 必填，生成签名的时间戳
                            nonceStr: info.nonceStr, // 必填，生成签名的随机串
                            signature: info.signature, // 必填，签名
                            jsApiList: [
                                'getLocation',
                                'scanQRCode',
                                'chooseImage',
                                'previewImage'
                            ] // 必填，需要使用的 JS 接口列表
                        });
                        wx.ready(function () {

                            that.$Message.success('微信SDK导入成功')
                            console.log('微信sdk导入成功')
                        });
                        wx.error(function (res) {
                            that.$Message.error('微信SDK导入失败', String(res))
                        });

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                        that.$Message.error('参数请求失败')
                    }
                }
            ).catch((res) => {
                that.$Message.error('参数请求失败')
                console.log(res, '请求出错')
            })
        },
        to_page(item) {
            this.$router.push({
                path: item.path
            })
        }
    }
}
</script>

<style  scoped>
.menu_txt {
    font-weight: 600;
    letter-spacing: 5px;
    font-size: 14px;
}

.iconybxm {
    font-size: 40px;
}

.icondiv {
    width: 60px;

}

.menu_item {
    width: 50%;
}

.menu_div {
    display: flex;
    flex-wrap: wrap;
}

.menu_button {
    margin: 10px;
    display: flex;
    padding: 0 10px;
    background-color: #1d70d4;
    color: #fff;
    height: 80px;
    border-radius: 5px;
    align-items: center;

}
</style>